import React from 'react'

const Labels = ({ data, classList , live }) => {
  return (
    <div className={`badge-container  justify-end items-end ${classList}`}>

      {data && data?.listing_at_group === 'NSE' ||
        data?.listing_at_group === 'BSE' ? (
        data?.security_type === 'SME' ? (
          <span
            className='badge live-status-badge'
            style={{
              background: '#1D53A2',
              color: '#FFFFFF'
            }}
          >
            <div
              className='liveUpcomingListed live'
              style={{ background: '#FFFFFF' }}
            ></div>
            {data?.listing_at_group} - SME
          </span>
        ) : (
          <span
            className='badge live-status-badge'
            style={{
              background: '#1D53A2',
              color: '#FFFFFF'
            }}
          >
            <div
              className='liveUpcomingListed live'
              style={{ background: '#FFFFFF' }}
            ></div>
            MainBoard
          </span>
        )
      ) : null}

      {data && data?.listing_at_group === 'NSE, BSE' && (
        <span
          className='badge live-status-badge'
          style={{
            background: '#1D53A2',
            color: '#FFFFFF'
          }}
        >
          <div
            className='liveUpcomingListed live'
            style={{ background: '#FFFFFF' }}
          ></div>
          {data?.security_type === 'SME' ? 'SME' : 'MainBoard'}
        </span>
      )}
      
      { 
      live !== true && (
        <span
          className='badge live-status-badge'
          style={{
            backgroundColor: data?.ipo_status?.background_color,
            color: data?.ipo_status?.color
          }}
        >
          <div
            className='liveUpcomingListed live'
            style={{
              backgroundColor: data?.ipo_status?.color
            }}
          ></div>
          {data?.ipo_status?.status}
        </span>
     )  }
    </div>
  )
}

export default Labels